import {
    FETCH_CUSTOMERS_STARTED,
    ADD_CUSTOMER_SUCCEEDED,
    ADD_CUSTOMER_FAILED,
    FETCH_CUSTOMERS_SUCCEEDED,
    RESET_ADD_CUSTOMER_STATE,
    DELETE_CUSTOMER_SUCCEEDED,
    DELETE_CUSTOMER_FAILED,
    RESET_DELETE_CUSTOMER_STATE,
    DELETE_CUSTOMER_STARTED,
    EDIT_CUSTOMER_SUCCEEDED,
    EDIT_CUSTOMER_FAILED,
    RESET_EDIT_CUSTOMER_STATE,
    RESET_CUSTOMERS,
    SEARCH_CUSTOMERS_STARTED,
    SEARCH_CUSTOMERS_SUCCEEDED,
    SEARCH_CUSTOMERS_FAILED,
    RESET_SEARCH_CUSTOMERS,
    FETCH_SINGLE_CUSTOMER_FAILED,
    FETCH_SINGLE_CUSTOMER_STARTED,
    FETCH_SINGLE_CUSTOMER_SUCCEEDED,
    RESET_FETCH_SINGLE_CUSTOMER,
} from "../actions/types/invoice.types";

const initialState = {
    customers: null,
    initialCustomers: [],
    addCustomerState: "idle",
    deleteState: "idle",
    updateCustomerState: "idle",
    fetchCustomersState: "loading",
    fetchSingleCustomerState: "idle",
    searchCustomerByFilterState: "idle",
    customersErrorMessage: "",
    singleCustomer: {},
    singleCustomerErrorMessage: "",
};

const invoiceCustomerReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case FETCH_CUSTOMERS_STARTED:
            return {
                ...state,
                fetchCustomersState: "loading",
            };
        case FETCH_SINGLE_CUSTOMER_STARTED:
            return {
                ...state,
                fetchSingleCustomerState: "loading",
            };
        case FETCH_SINGLE_CUSTOMER_SUCCEEDED:
            return {
                ...state,
                fetchSingleCustomerState: "success",
                singleCustomer: payload,
            };
        case FETCH_SINGLE_CUSTOMER_FAILED:
            return {
                ...state,
                fetchSingleCustomerState: "failed",
                customersErrorMessage: payload,
            };
        case RESET_FETCH_SINGLE_CUSTOMER:
            return {
                ...state,
                fetchSingleCustomerState: "idle",
            };

        case ADD_CUSTOMER_SUCCEEDED: {
            return {
                ...state,
                addCustomerState: "success",
            };
        }

        case ADD_CUSTOMER_FAILED: {
            return {
                ...state,
                addCustomerState: "failed",
                customersErrorMessage: payload,
            };
        }

        case RESET_ADD_CUSTOMER_STATE: {
            return {
                ...state,
                addCustomerState: "idle",
            };
        }

        case SEARCH_CUSTOMERS_STARTED:
            return {
                ...state,
                searchCustomerByFilterState: "loading",
            };

        case SEARCH_CUSTOMERS_FAILED:
            return {
                ...state,
                searchCustomerByFilterState: "failed",
            };

        case SEARCH_CUSTOMERS_SUCCEEDED: {
            const data = Array.isArray(payload.data) ? payload.data : [];

            return {
                ...state,
                searchCustomerByFilterState: "success",
                customers: data,
            };
        }

        case EDIT_CUSTOMER_SUCCEEDED: {
            return {
                ...state,
                updateCustomerState: "success",
            };
        }

        case EDIT_CUSTOMER_FAILED: {
            return {
                ...state,
                updateCustomerState: "failed",
                customersErrorMessage: payload,
            };
        }

        case RESET_EDIT_CUSTOMER_STATE: {
            return {
                ...state,
                updateCustomerState: "idle",
            };
        }

        case FETCH_CUSTOMERS_SUCCEEDED: {
            const data = Array.isArray(payload) ? payload : [];

            return {
                ...state,
                fetchCustomersState: "success",
                customers: data,
                initialCustomers: data,
            };
        }

        case DELETE_CUSTOMER_STARTED: {
            return {
                ...state,
                deleteState: "loading",
            };
        }

        case DELETE_CUSTOMER_SUCCEEDED: {
            return {
                ...state,
                deleteState: "success",
            };
        }

        case DELETE_CUSTOMER_FAILED: {
            return {
                ...state,
                deleteState: "failed",
                customersErrorMessage: payload,
            };
        }

        case RESET_DELETE_CUSTOMER_STATE: {
            return {
                ...state,
                deleteState: "idle",
            };
        }

        case RESET_SEARCH_CUSTOMERS:
            return {
                ...state,
                searchCustomerByFilterState: "idle",
            };

        case RESET_CUSTOMERS:
            return {
                ...state,
                customers: state.initialCustomers,
            };

        default:
            return state;
    }
};

export { invoiceCustomerReducer };
